module.exports = __webpack_public_path__ + "img/data-img.160031f4.png";